import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=7f2bbd94&scoped=true"
import script from "./ImportFile.vue?vue&type=script&lang=js"
export * from "./ImportFile.vue?vue&type=script&lang=js"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=7f2bbd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2bbd94",
  null
  
)

export default component.exports